import { chartLayoutStorageKey, chartSettingsStorageKey } from '../types/settings';

export function clearLocalChartState(): void {
  localStorage.removeItem(chartLayoutStorageKey);
  localStorage.removeItem(chartSettingsStorageKey);
}
